import _objectWithoutProperties from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["icon", "text", "children"];
var __jsx = React.createElement;
import React from 'react';
import { Wrapper } from './styles';
var Item = function Item(_ref) {
  var icon = _ref.icon,
    text = _ref.text,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return __jsx(Wrapper, props, icon, __jsx("span", null, text), children);
};
export default Item;